// Implements: F-UIX-020, F-UIX-007
/**
 * A labelled native `<select>` over a closed list. Pure presentation.
 *
 * Native for the same reason as `ScopeSelector`: keyboard operation and
 * announcement come with the element (F-UIX-007). The person picks a label;
 * the value sent is always one of the closed literals, never free text.
 */

import type { ReactElement } from "react";

import { Select } from "../../../shared/ui/atoms/Select";
import { Field } from "../../../shared/ui/molecules/Field";

export interface ClosedOption {
  readonly value: string;
  readonly label: string;
}

export interface ClosedSelectProps {
  readonly id: string;
  readonly label: string;
  readonly options: readonly ClosedOption[];
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly disabled: boolean;
}

export function ClosedSelect({
  id,
  label,
  options,
  value,
  onChange,
  disabled,
}: ClosedSelectProps): ReactElement {
  return (
    <Field id={id} label={label}>
      <Select id={id} value={value} options={options} onChange={onChange} disabled={disabled} />
    </Field>
  );
}
